import { render } from "./OctaveView.vue?vue&type=template&id=5c9f4f9e&ts=true"
import script from "./OctaveView.vue?vue&type=script&lang=ts"
export * from "./OctaveView.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__